module.exports = __webpack_public_path__ + "media/images/rawnfresh-06f77971ac51ce410565eeb0f17c15d8.svg";